<template>
  <span>
    <v-dialog v-model="openDialog" persistent max-width="600px">
      <v-card>
        <v-form v-model="validSyntax">
          <v-card-text>
            <v-textarea
              class="biggercode"
              rows="20"
              :disabled="disabled"
              :maxlength="maxlength"
              :error-messages="errors"
              :rules="all_rules"
              :label="label"
              ref="atinput"
              v-model="typecatcher"
            ></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="warning" flat @click="dialogDismiss">{{ $t('common.cancel') }}</v-btn>
            <v-btn
              :disabled="!validSyntax || loading"
              color="primary"
              flat
              @click="dialogChanged"
            >{{ $t('common.save') }}</v-btn>
          </v-card-actions>
        </v-form>
        <span v-if="pvalue.type == 'formula'">
          <v-footer
            height="auto"
            :color="!!parseres && parseres.haserror ? 'warning' : 'success'"
            class="py-2 pl-3 white--text"
          >
            <span v-if="!!parseres && !parseres.haserror">
              {{ $t("admin.input.validexpression") }}
              <br />
              {{ $t("admin.input.usedvars") }}
              <span class="biggercode">{{ validExpressionText }}</span>
            </span>
            <span v-if="!!parseres && parseres.haserror">
              {{ this.$i18n.t("admin.input.invalidexpression") }}
              <pre>{{ parseres.error }}</pre>
            </span>
          </v-footer>
        </span>
      </v-card>
    </v-dialog>

    <v-tooltip bottom close-delay="1000">
      <template v-slot:activator="{ on }">
        <span v-on="on">
          <v-icon v-if="pvalue.type == 'formula'">mdi-function-variant</v-icon>
          <v-icon v-if="pvalue.type == 'json'">mdi-json</v-icon>
        </span>
      </template>
      <pre class="biggercode">{{ pvalue.value }}</pre>
    </v-tooltip>
  </span>
</template>

<script>
import { trim, isEmpty, join } from "lodash";
import Vue from "vue";
import ATInputMixin from "./ATInputMixin.js";

export default {
  mixins: [ATInputMixin],
  data() {
    return {
      errors: [],
      loading: false,
      parseres: undefined,
      openDialog: false,
      validSyntax: "",
      typecatcher: this.text
    };
  },
  watch: {
    text() {
      this.typecatcher = this.text;
    },
    editing() {
      this.openDialog = this.editing;
    },
    typecatcher() {
      this.lchanged();
    },
    openDialog() {
      //      if (this.pvalue.type == "formula" && this.openDialog)
      //        this.lchanged(this.pvalue.value);
      let tmps = this.pvalue.value;
      this.typecatcher = tmps;
      this.lchanged();
    }
  },
  computed: {
    validExpressionText() {
      // TODO: nella versione originale veniva modificata direttametne la variabile parseres.vars
      if (this.parseres && this.parseres.vars) {
        let arr = this.parseres.vars;
        return join(arr.sort(), ", ");
      }
      return undefined;
    },
    all_rules() {
      let rules = [];
      if (this.required) rules.push(value => !!trim(value) || "Required.");
      if (this.pvalue.type == "json")
        rules.push(value => {
          try {
            JSON.parse(value);
            return true;
          } catch (err) {
            this.$log.debug(err.message);
            return err.message;
          }
        });
      return rules;
    },
    pvalue() {
      let check = this.typecatcher;
      if (isEmpty(check))
        return {
          value: "",
          type: "empty"
        };
      let value;
      if (check.charAt(0) === "{") {
        let text;
        try {
          let json = JSON.parse(check);
          text = JSON.stringify(json, null, 2);
        } catch (e) {
          // TODO: mettere logger
          this.$log.debug(e);
        }
        value = {
          value: text,
          type: "json"
        };
      } else {
        value = {
          value: check,
          type: "formula"
        };
      }
      return value;
    }
  },
  methods: {
    dialogDismiss() {
      this.blur();
      //      this.typecatcher = this.text;
    },
    dialogChanged() {
      this.dialogDismiss();
      this.$log.debug("1 changed to: ", this.typecatcher);
      this.$log.debug("2 changed to: ", this.text);
      this.$log.debug("3 changed to: ", this.pvalue);
      this.changed(this.typecatcher);
    },
    async lchanged() {
      let text = this.typecatcher;
      if (isEmpty(text)) {
        return;
      }
      this.$log.debug("changed =>");
      this.errors = [];
      this.loading = true;
      if (this.pvalue.type == "formula") {
        let res = await Vue.axios.post(Vue.$url("expression/check"), {
          expression: text
        });
        res = res.data;
        this.$log.debug(
          `expression ${text} checked, result: ${JSON.stringify(res, null, 2)}`
        );
        if (res.haserror) {
          this.errors.push(res.error);
        }
        this.parseres = res;
      }
      this.loading = false;
      this.$log.debug("<= changed");
    }
  }
};
</script>

<style>
.biggercode {
  font-family: "Roboto Mono";
  font-size: 14px;
}
.smallercode {
  font-family: "Roboto Mono";
  font-size: 11px;
}
</style>